if (!customElements.get('pickup-details')) {
    class PickupDetails extends HTMLElement {
      constructor() {
        super();
        this.firstCursor = '';
        this.lastCursor = '';
        this.searchTerm = '';
        this.editId = '';
        this.searchType = '';
        this.selectedIds = new Set();
      }
  
      connectedCallback() {
        this.setupEvents();
        this.fetchPincodes();
      }
  
      setupEvents() {
        const searchBtn = this.querySelector('.pickup-details-search-button');
        const searchInput = this.querySelector('.pickup-details-search-input');
        const clearIcon = this.querySelector('.pickup-details-icon-clear');
        const editForm = this.querySelector('.pickup-details-edit-form');
        this.downloadBtn = this.querySelector('.pickup-download-csv');
        this.isMasterDashboardUser = !!this.querySelector('.table-select-option');
        this.customerName = this.getAttribute('data-customer-name') || '';
        this.customerEmail = this.getAttribute('data-customer-email') || '';
        this.querySelector('.activity-log-trigger')?.addEventListener('click', () => this.showActivityLog());
        this.querySelector('.activity-log-close')?.addEventListener('click', () => {
          this.querySelector('.activity-log-popup')?.classList.add('hidden');
        });
  
        this.querySelector('.pickup-details-next-button')?.addEventListener('click', () => this.fetchPincodes({ direction: 'next' }));
        this.querySelector('.pickup-details-prev-button')?.addEventListener('click', () => this.fetchPincodes({ direction: 'prev' }));
        this.querySelector('.pickup-details-cancel-button')?.addEventListener('click', () => this.closeModal());
        this.downloadBtn?.addEventListener('click', () => {
          this.downloadCsv();
        })
  
        searchBtn?.addEventListener('click', () => {
          this.searchTerm = searchInput.value.trim();
          this.fetchPincodes();
        });
  
        clearIcon?.addEventListener('click', () => {
          searchInput.value = '';
          this.searchTerm = '';
          this.toggleSearchIcons(false);
          this.fetchPincodes();
        });
  
        searchInput?.addEventListener('keydown', (e) => {
          if (e.key === 'Enter') {
            this.searchTerm = searchInput.value.trim();
            this.fetchPincodes();
          }
        });
  
        searchInput?.addEventListener('input', (e) => {
          this.toggleSearchIcons(e.target.value.length > 0);
        });
  
        editForm?.addEventListener('submit', (e) => {
          e.preventDefault();
          this.updatePincode();
        });
  
        this.querySelector('.pickup-details-delete-button')?.addEventListener('click', () => {
          if (this.selectedIds.size === 0) return;
          this.deleteSelected();
        });
      }
  
      toggleSearchIcons(showClear) {
        const clearIcon = this.querySelector('.pickup-details-icon-clear');
        showClear ? clearIcon?.classList.remove('hidden') : clearIcon?.classList.add('hidden');
      }

      async downloadCsv() {
        try {
          this.downloadBtn.classList.add('spinner-loading');
          const res = await fetch('https://snooplaypinuat.marmeto.com/api/downloadCsv?type=pickup');
          const json = await res.json();
      
          if (!json.data || json.data.length === 0) {
            alert('No data to download.');
            return;
          }
      
          const headers = [
            "Pickup District Pincode",
            "Pickup District",
            "State",
            "Metro",
            "Product Name",
            "Product ID",
            "Vendor Name",
            "COD STATUS",
            "Vendor Status - SDD/Non-SDD"
          ];
      
          const rows = json.data.map(item => [
            item.pickupDistrictPincode || '',
            item.pickupDistrict || '',
            item.state || '',
            item.metro || '',
            item.productName || '',
            item.productId || '',
            item.vendorName || '',
            item.cod || '',
            item.vendorStatus || ''
          ]);
      
          const csvContent = [headers, ...rows]
            .map(row => row.map(cell => `"${cell.replace(/"/g, '""')}"`).join(','))
            .join('\n');
      
          const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
          const url = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = 'pickup_details.csv';
          a.style.display = 'none';
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          URL.revokeObjectURL(url);
        } catch (err) {
          alert('❌ Failed to download CSV.');
          console.error(err);
        }finally {
          this.downloadBtn.classList.remove('spinner-loading');
        }
      };
      
  
      fetchPincodes({ direction = '' } = {}) {
        const tbody = this.querySelector('.pickup-details-tbody');
        const nextBtn = this.querySelector('.pickup-details-next-button');
        const prevBtn = this.querySelector('.pickup-details-prev-button');
        const statusMsg = this.querySelector('.pickup-details-search-status');
        const deleteBtn = this.querySelector('.pickup-details-delete-button');
        this.searchType = this.querySelector('.pickup-details-search-type')?.value;
  
        tbody.innerHTML = `<tr><td colspan="11" class="pickup-details-loading-row">Loading...</td></tr>`;
        this.toggleSearchIcons(!!this.searchTerm);
        statusMsg.textContent = '';
        this.selectedIds.clear();
        deleteBtn?.classList.add('hidden');
  
        const payload = {
          search: this.searchTerm,
          searchType: this.searchType,
          firstId: direction === 'prev' ? this.firstCursor : "",
          lastId: direction === 'next' ? this.lastCursor : "",
          limit: "200"
        };
  
        fetch("https://snooplaypinuat.marmeto.com/api/pickup-pincode/list", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload)
        })
          .then(res => res.json())
          .then(data => {
            this.lastCursor = data.nextCursor || '';
            this.firstCursor = data.prevCursor || '';
  
            if (data.records.length > 0) {
              this.renderTable(data.records);
              statusMsg.textContent = this.searchTerm ? `Showing results for "${this.searchTerm}"` : '';
            } else {
              tbody.innerHTML = `<tr><td colspan="11" class="pickup-details-loading-row">No data found</td></tr>`;
              statusMsg.textContent = this.searchTerm ? `No results found for "${this.searchTerm}"` : 'No data found';
            }
  
            nextBtn.style.display = data.isLastPage ? 'none' : 'flex';
            prevBtn.style.display = data.isFirstPage ? 'none' : 'flex';
          })
          .catch(() => {
            tbody.innerHTML = `<tr><td colspan="11" class="pickup-details-loading-row error">Failed to load data</td></tr>`;
            statusMsg.textContent = 'Something went wrong while fetching results.';
          });
      }
  
      renderTable(records) {
        const tbody = this.querySelector('.pickup-details-tbody');
        const deleteBtn = this.querySelector('.pickup-details-delete-button');
        tbody.innerHTML = '';
        this.selectedIds.clear();

        records.forEach(item => {
          const row = document.createElement('tr');

          // Add checkbox column only if permitted
          let checkboxCell = '';
          if (this.isMasterDashboardUser) {
            checkboxCell = `<td><input type="checkbox" data-id="${item._id}" class="pickup-details-checkbox"></td>`;
          }

          row.innerHTML = `
            ${checkboxCell}
            <td>${item.pickupDistrictPincode}</td>
            <td>${item.pickupDistrict}</td>
            <td>${item.state}</td>
            <td>${item.metro}</td>
            <td>${item.productName}</td>
            <td>${item.productId}</td>
            <td>${item.vendorName}</td>
            <td>${item.cod}</td>
            <td>${item.vendorStatus}</td>
            <td><button class="pickup-details-edit-button">Edit</button></td>
          `;
          row.querySelector('.pickup-details-edit-button').addEventListener('click', () => this.openModal(item));
          if (this.isMasterDashboardUser) {
            const checkbox = row.querySelector('.pickup-details-checkbox');
            checkbox?.addEventListener('change', (e) => {
              const checkboxes = this.querySelectorAll('.pickup-details-checkbox');
              const currentCheckbox = e.target;

              if (currentCheckbox.checked) {
                checkboxes.forEach(cb => {
                  if (cb !== currentCheckbox) cb.checked = false;
                });

                this.selectedIds.clear();
                this.selectedIds.add(currentCheckbox.getAttribute('data-id'));
              } else {
                this.selectedIds.delete(currentCheckbox.getAttribute('data-id'));
              }

              deleteBtn.classList.toggle('hidden', this.selectedIds.size !== 1);
            });
          }

          tbody.appendChild(row);
        });
      }
  
      deleteSelected() {
        if (!this.isMasterDashboardUser) return;
        
        const data = {}
        const ids = Array.from(this.selectedIds);
        if (ids.length !== 1) {
          alert('Please select only one row to delete.');
          return;
        }
        data['ids'] = ids;
        data['user'] = {
          'name': this.customerName,  
          'email': this.customerEmail
        }

        if (!confirm('Are you sure you want to delete this row?')) return;

        fetch("https://snooplaypinuat.marmeto.com/api/pickup-pincode/delete", {
          method: "DELETE",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(data)
        })
          .then(res => {
            if (!res.ok) throw new Error(`Error ${res.status}`);
            return res.json();
          })
          .then(() => {
            alert('✅ Deleted successfully');
            this.selectedIds.clear();
            this.querySelector('.pickup-details-delete-button')?.classList.add('hidden');
            setTimeout(() => this.fetchPincodes(), 2000);
          })
          .catch(() => alert('❌ Failed to delete'));
      }
  
      openModal(data) {
        const modal = this.querySelector('.pickup-details-modal-overlay');
        const form = this.querySelector('.pickup-details-edit-form');
        this.editId = data._id;
        modal.classList.add('active');
  
        for (let key in data) {
          const field = form.elements.namedItem(key);
          if (field) field.value = data[key];
        }
      }
  
      closeModal() {
        const modal = this.querySelector('.pickup-details-modal-overlay');
        modal.classList.remove('active');
      }
  
      updatePincode() {
        const form = this.querySelector('.pickup-details-edit-form');
        const status = this.querySelector('.pickup-details-modal-status');
        const data = {};
        [...form.elements].forEach(el => {
          if (el.name) data[el.name] = el.value;
        });
        data['user'] = {
          'name': this.customerName,
          'email': this.customerEmail
        }
  
        fetch(`https://snooplaypinuat.marmeto.com/api/pickup-pincode/${this.editId}`, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(data)
        })
          .then(res => res.json())
          .then(() => {
            status.textContent = '✅ Data updated successfully';
            status.classList.remove('error');
            status.classList.add('success');
            setTimeout(() => {
              this.closeModal();
              this.fetchPincodes();
            }, 2000);
          })
          .catch(() => {
            status.textContent = '❌ Failed to update data';
            status.classList.remove('success');
            status.classList.add('error');
          });
      }

    showActivityLog() {
      const data = {
        searchType: "target.model",
        search: "PincodePickupDetails"
      };

      fetch('https://snooplaypinuat.marmeto.com/api/activity/list', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      })
        .then(res => res.json())
        .then(data => this.renderActivityLog(data.records.slice(0, 5)))
        .catch(() => alert('❌ Failed to load activity log'));
    }

    renderActivityLog(records) {
      const wrapper = this.querySelector('.activity-log-accordion-wrapper');
      const template = wrapper.querySelector('[data-template]');
      wrapper.querySelectorAll('.activity-log-item:not([data-template])').forEach(el => el.remove());

      records.forEach((record, index) => {
        const clone = template.cloneNode(true);
        clone.classList.remove('hidden');
        clone.removeAttribute('data-template');

        const user = record.user?.name || 'Unknown User';
        const action = record.action;
        const time = new Date(record.timestamp).toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' });

        // Title
        clone.querySelector('.accordion-title .accordion-title-text').textContent = `${user} - ${action}`;

        // Content
        const content = clone.querySelector('.accordion-content');
        let html = `<p><strong>Time:</strong> ${time}</p>`;

        if (action === 'IMPORT_CSV_PICKUP') {
          html += `<p><strong>File:</strong> ${record.details?.file?.name || 'N/A'}</p>`;
        }

        if (action === 'DELETE_PICKUP_RECORD') {
          const recordData = record.details?.bulkRecords?.[0] || {};
          html += this.buildTable([recordData]);
        }

        if (action === 'UPDATE_PICKUP_RECORD') {
          const { before = {}, after = {} } = record.details?.changes || {};
          html += `<p><strong>Before:</strong></p>${this.buildTable([before])}`;
          html += `<p><strong>After:</strong></p>${this.buildTable([after])}`;
        }

        content.innerHTML = html;

        // Accordion toggle
        clone.querySelector('.accordion-title').addEventListener('click', () => {
          clone.classList.toggle('open');
        });

        wrapper.appendChild(clone);
      });

      this.querySelector('.activity-log-popup')?.classList.remove('hidden');
    }

    buildTable(records) {
      if (!records.length) return '<p>No data available</p>';
      const keys = Object.keys(records[0]).filter(k => k !== '__v' && k !== '_id' && k !== 'createdAt' && k !== 'updatedAt');
      const rows = records.map(record => {
        return `<tr>${keys.map(k => `<td>${record[k] || ''}</td>`).join('')}</tr>`;
      });
      const header = `<tr>${keys.map(k => `<th>${k}</th>`).join('')}</tr>`;
      return `<table class="log-table">${header}${rows.join('')}</table>`;
    }
    }
  
    customElements.define('pickup-details', PickupDetails);
  }
  

  if (!customElements.get('upload-pincode')) {
    class UploadPincode extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.triggerBtn = this.querySelector('.upload-pincode-trigger');
        this.modal = this.querySelector('.upload-pincode-modal-overlay');
        this.closeBtn = this.querySelector('.upload-pincode-close');
        this.fileInput = this.querySelector('.upload-pincode-file-input');
        this.uploadBtn = this.querySelector('.upload-pincode-submit-btn');
        this.statusText = this.querySelector('.upload-pincode-status');
        this.filenameText = this.querySelector('.upload-pincode-filename');
        this.customerName = this.getAttribute('data-customer-name') || '';
        this.customerEmail = this.getAttribute('data-customer-email') || '';

        this.requiredHeaders = [
          'Pickup District Pincode',
          'Pickup District',
          'State',
          'Metro',
          'Product Name',
          'Product ID',
          'Vendor Name',
          'COD STATUS',
          'Vendor Status - SDD/Non-SDD'
        ];

        this.triggerBtn.addEventListener('click', () => this.modal.style.display = 'flex');
        this.closeBtn.addEventListener('click', () => this.modal.style.display = 'none');
        this.uploadBtn.addEventListener('click', () => this.validateAndUpload());
        this.fileInput.addEventListener('change', () => this.displayFilename());
      }

      displayFilename() {
        const file = this.fileInput.files[0];
        this.filenameText.textContent = file ? `Selected File: ${file.name}` : '';
      }

      validateAndUpload() {
        const file = this.fileInput.files[0];
        this.statusText.className = 'upload-pincode-status';

        if (!file || !file.name.endsWith('.csv')) {
          this.statusText.textContent = 'Please select a valid .csv file';
          this.statusText.classList.add('error');
          return;
        }

        if (file.name.includes(' ')) {
          this.statusText.textContent = 'File name should not contain spaces. Use underscores instead (e.g., new_products.csv)';
          this.statusText.classList.add('error');
          return;
        }

        const reader = new FileReader();
        reader.onload = (e) => {
          const lines = e.target.result.split(/\r?\n/);
          const headers = lines[0].split(',').map(h => h.trim());

          const missing = this.requiredHeaders.filter(h => !headers.includes(h));
          if (missing.length) {
            this.statusText.textContent = 'Missing headers: ' + missing.join(', ');
            this.statusText.classList.add('error');
          } else {
            this.statusText.textContent = '✅ All headers are valid. Uploading...';
            this.statusText.classList.add('success');
            this.sendToApi(file);
          }
        };
        reader.readAsText(file);
      }

      sendToApi(file) {
        const formData = new FormData();
        formData.append('file', file);
        let url = `https://snooplaypinuat.marmeto.com/api/csv/upload/pickup?type=update&name=${this.customerName}&email=${this.customerEmail}`;

        fetch(url, {
          method: 'POST',
          body: formData
        })
        .then(res => res.json())
        .then(data => {
          this.statusText.textContent = '✅ File uploaded successfully';
          this.statusText.classList.remove('error');
          this.statusText.classList.add('success');
          setTimeout(() => {
            this.modal.style.display = 'none';
            this.statusText.textContent = '';
            this.filenameText.textContent = '';
            this.fileInput.value = '';
            window.location.reload(); // Reload to reflect changes
          }, 2000);
        })
        .catch(err => {
          this.statusText.textContent = '❌ Upload failed. Please try again';
          this.statusText.classList.remove('success');
          this.statusText.classList.add('error');
        });
      }
    }

    customElements.define('upload-pincode', UploadPincode);
  }